var _path, _polygon, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F0F0F0"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M138.371,356.174l-63.382,80.837C121.313,483.341,185.306,512,256,512 c105.83,0,196.644-64.229,235.631-155.826H138.371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#496E2D"
    },
    d: "M492.029,156.753C453.26,64.662,362.188,0,256,0C185.306,0,121.313,28.659,74.989,74.989 l64.11,81.764L492.029,156.753L492.029,156.753z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.652,188.29v134.492h447.53C508.924,301.491,512,279.107,512,256c0-23.442-3.158-46.142-9.061-67.71L55.652,188.29 L55.652,188.29z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2001D"
    },
    d: "M74.98,74.98c-99.974,99.974-99.974,262.065,0,362.04C116.293,395.707,156.026,355.974,256,256 L74.98,74.98z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "103.61,189.217 120.185,240.233 173.831,240.233 130.433,271.765 147.007,322.783  103.61,291.252 60.211,322.783 76.789,271.765 33.391,240.233 87.033,240.233 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.107,
    y: 256,
    style: {
      fill: "#F0F0F0"
    },
    width: 97.024,
    height: 44.522
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "170.5,204.959 154.759,189.217 103.611,240.365 52.463,189.217 36.722,204.959 87.915,256.061 36.722,307.255  52.463,322.783 103.611,271.727 154.759,322.783 170.5,307.255 119.307,256.061 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMz);
export default __webpack_public_path__ + "static/media/mz.2fa5e30f38f25d8edfaa308f3caef824.svg";
export { ForwardRef as ReactComponent };